const IF = (condition, value, defaultValue) => (condition ? value : defaultValue);

export default IF;
